import { put, takeLatest } from 'redux-saga/effects';

import { requestStateList } from '../../../services/state';
import { fetchStateListFailure, fetchStateListRequest, fetchStateListSuccess } from '../../reducers/state';

export function* watchStateSaga() {
  yield takeLatest(fetchStateListRequest, fetchStateList);
}

/**
 *
 * @param {*} param0
 */
function* fetchStateList({ payload }) {
  try {
    const response = yield requestStateList(payload);
    yield put(fetchStateListSuccess(response));
  } catch (error) {
    yield put(fetchStateListFailure('Failed to get list of Leads'));
  }
}
